import "./Features.scss";
import {
  IoMusicalNote,
  IoMusicalNotes,
  IoPeopleOutline,
  IoPersonOutline,
  IoSunnyOutline,
  IoCheckmarkSharp,
  IoCloseSharp
} from "react-icons/io5";
import React from "react";

import { useNavigate } from "react-router-dom";

const Features = () => {
  const smile = "\u{1F604}";

  const navigate = useNavigate();

  // const slide = useRef() as React.MutableRefObject<HTMLDivElement>;
  // const slideOne = useRef() as React.MutableRefObject<HTMLDivElement>;

  // const observer = new IntersectionObserver((entries) => {
  //   entries.forEach((entry) => {
  //     const intersecting = entry.isIntersecting;
  //     if (intersecting) {
  //       setIsIntersecting(true);
  //       entry.target.classList.add("slide-out");
  //     }
  //     if (!intersecting) {
  //       entry.target.classList.remove("slide-out");
  //       setIsIntersecting(false);
  //     }
  //   });
  // });

  // useEffect(() => {
  //   observer.observe(slide.current);
  //   observer.observe(slideOne.current);
  // }, [isIntersecting]);

  // const deferredSetQueryHandler = useCallback(
  //   debounce((event: React.ChangeEvent<HTMLInputElement>) => {
  //     setQuery(event.target.value);
  //   }, 500),
  //   []
  // );

  const goTo = () => {
    if (localStorage.getItem("User") !== null) {
      navigate("/cabinet");
    } else {
      navigate("/loginmodal");
    }
  };

  return (
    <div>
      <div>
        <div className="feature-features">
          <div
            // ref={slideOne}
            className="feature-features-listbox feature-list-1"
          >
            <div className="feature-list ">
              <li>
                <IoMusicalNote className="feature-list-icon" /> Режим екрану
              </li>
              <li>
                <IoMusicalNote className="feature-list-icon" />
                Створення підбірок
              </li>
              <li>
                <IoMusicalNote className="feature-list-icon" />
                Зміна тональності
              </li>
            </div>
          </div>
          <div className="feature-imgbox">
            <img
              className="feature-imgbox-img"
              src="images/laptop.png"
              alt="a photo of a laptop"
            />
            <div className="feature-imgbox-motion-circle">
              <div className="music-note_1">
                <IoMusicalNotes className="note-style" />
              </div>
              <div className="music-note_2">
                <IoMusicalNotes className="note-style" />
              </div>
              <div className="music-note_3">
                <IoMusicalNotes className="note-style" />
              </div>
              <div className="music-note_4">
                <IoMusicalNotes className="note-style" />
              </div>
            </div>
          </div>
          <div
            // ref={slide}
            className="feature-features-listbox feature-list-2"
          >
            <div className="feature-list ">
              <li>
                <IoMusicalNote className="feature-list-icon" />
                Робота у команді
              </li>
              <li>
                <IoMusicalNote className="feature-list-icon" />
                Легкий пошук
              </li>
              <li>
                <IoMusicalNote className="feature-list-icon" />
                Медіа ресурси
              </li>
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center text-center">
          <div className="box-open">
            <p className="box-open-text-1"> Створи новий збірник пісень</p>
            <p className="box-open-text-2">Приватний або загальний</p>
            <IoMusicalNote className="icon-1 note-style" />
            <IoMusicalNote className="icon-2 note-style" />
            <IoMusicalNote className="icon-3 note-style" />
            <IoMusicalNote className="icon-4 note-style" />
            <IoMusicalNote className="icon-5 note-style" />
            <div className="text-center">
              <button className="create-button" onClick={goTo}>
                Створити
              </button>
            </div>
          </div>
        </div>

        <div className="title-for-options">Тарифні плани</div>

        <div className="options">
          <div className="options-message">
            <div className="options-message-inner">
              Наразі тарифи відключено. Всі інструменти додатка доступні
              безкоштовно всім користувачам. У подальшому деякі функції стануть
              платними, але не хвилюйтесь - тарифи будуть зовсім невеликими.{" "}
              {smile}{" "}
              <p>
                Чекаємо на ваші відгуки. Наша мета - зробити цей проект
                максимально зручним і корисним!
              </p>
            </div>
          </div>
          <div className="options-box options-box-one">
            <IoSunnyOutline className="options-icon" />
            <p>
              Вільний <br /> <span>Безкоштовно</span>
            </p>
            <ul className="plan">
              <li className="plan-item">
                {" "}
                <IoCheckmarkSharp className="icon" />
                Один збірник
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                15 пісень
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Режим екрану
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Вибір тональності
              </li>
              <li>
                <IoCloseSharp className="icon" />
                Завантаження файлів
              </li>
              <li>
                <IoCloseSharp className="icon" />
                Створення підбірок
              </li>
              <li>
                <IoCloseSharp className="icon" />
                Запрошення учасників
              </li>
              <li>
                {" "}
                <IoCloseSharp className="icon" />
                Робота у команді
              </li>
            </ul>
          </div>
          <div className="options-box options-box-one">
            <IoPersonOutline className="options-icon" />
            <p>
              Індивідуальний <br />
              <span>...гр. / місяць</span>
            </p>
            <ul className="plan">
              <li className="plan-item">
                {" "}
                <IoCheckmarkSharp className="icon" />
                Два збірники
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Пісень необмежено
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Режим екрану
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Вибір тональності
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Завантаження файлів
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Створення підбірок
              </li>
              <li>
                <IoCloseSharp className="icon" />
                Запрошення учасників
              </li>
              <li>
                {" "}
                <IoCloseSharp className="icon" />
                Робота у команді
              </li>
            </ul>
          </div>
          <div className="options-box options-box-one">
            <IoPeopleOutline className="options-icon" />
            <p>
              Командний <br />
              <span>...гр. / місяць</span>
            </p>
            <ul className="plan">
              <li className="plan-item">
                {" "}
                <IoCheckmarkSharp className="icon" />
                Два збірники
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Пісень необмежено
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Режим екрану
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Вибір тональності
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Завантаження файлів
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Створення підбірок
              </li>
              <li className="plan-item">
                <IoCheckmarkSharp className="icon" />
                Запрошення учасників
              </li>
              <li className="plan-item">
                {" "}
                <IoCheckmarkSharp className="icon" />
                Робота у команді
              </li>
            </ul>
          </div>
          <div className="action-btn">
            <button
              className="register-button"
              onClick={() => navigate("/loginmodal")}
            >
              Поїхали!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
